import React, { Suspense, lazy, useState } from 'react';

import SectionBreakTitle, { SectionColor } from '@components/SectionBreakTitle';
import { useSubscribeForm } from '@contexts/SubscribeFormContext';
import useEventTracking from '@hooks/useEventTracking';
import { Page } from '@tracking';
import { YOUNG_PROFESSIONALS_PLAN } from '@utils/constants';

import { SubscribeProps } from '.';
import CorporateInquiry from './OfferSelection/CorporateInquiry';
import MobileOffer from './OfferSelection/MobileOffer';

const PaymentForm = lazy(() => import('./Forms/PaymentForm'));

const MobileMultipleOffers = ({
  defaultSelectedOffer,
  offers,
}: Pick<SubscribeProps, 'defaultSelectedOffer' | 'description' | 'offers'>) => {
  const [selectedOffer, setSelectedOffer] = useState(defaultSelectedOffer);
  const { Track } = useEventTracking({ page: Page.MultiOffersSubscribe });
  const {
    user: { isYPEligible, stripeCustomerId },
  } = useSubscribeForm();
  const isYPPlan = selectedOffer.code.includes(YOUNG_PROFESSIONALS_PLAN);
  const showPaymentForm = stripeCustomerId && (!isYPPlan || (isYPPlan && isYPEligible));

  return (
    <Track>
      <div className="px-16 sm:px-28" data-testid="subscribe-mobile-multiple-offers">
        <div className="mx-auto max-w-full lg:max-w-[1040px]">
          <h3 className="mb-24 mt-0 border-0 border-b border-solid border-grayscale-beige pb-8 text-center font-suisse-works text-headline-xxs">
            Finalize your subscription
          </h3>
          <div className="mb-48 grid grid-cols-1 sm:mb-0 sm:grid-cols-2 sm:gap-28 lg:gap-64">
            <div>
              {offers.map((offer, index) => (
                <MobileOffer
                  key={`offer-card-${index}`}
                  offer={offer}
                  selectedOfferCode={selectedOffer.code}
                  setSelectedOffer={setSelectedOffer}
                />
              ))}
            </div>
            {showPaymentForm && (
              <div className="m-auto w-full max-w-md sm:max-w-full">
                <SectionBreakTitle
                  title="Payment information"
                  titleClassName="text-black"
                  color={selectedOffer.isPro ? SectionColor.Gold : SectionColor.Magenta}
                  className="mb-24 mt-32 w-full"
                />
                <Suspense>
                  <PaymentForm
                    buttonText="Subscribe"
                    presentedOfferCodes={offers.map((offer) => offer.code)}
                    selectedOffer={selectedOffer}
                    stripeCustomerId={stripeCustomerId}
                  />
                </Suspense>
              </div>
            )}
          </div>
          <CorporateInquiry />
        </div>
      </div>
    </Track>
  );
};

export default MobileMultipleOffers;
